// Add your JS customizations here
jQuery(document).ready(function($) { 
	setTimeout(function(){
		$('.page-template-home').addClass('loaded');
	}, 1000);

	if ($.cookie('invert') == 'true') {
		$('.swappable').addClass('invert');
	}

	

	$(window).scroll(function() {

		if ($(this).scrollTop() > 0) {
    		$('#main_nav').addClass('scrolled').removeClass('not_scrolled');
    	} else {
    		$('#main_nav').removeClass('scrolled').addClass('not_scrolled');
    	}

	});

	if ($(window).width() < 991) {

		new WOW().init();

		$('#page').scroll(function() {
			if ($(this).scrollTop() > 0) {
	    		$('#main_nav').addClass('scrolled').removeClass('not_scrolled');
	    	} else {
	    		$('#main_nav').removeClass('scrolled').addClass('not_scrolled');
	    	}
		});

	} else {

		new WOW().init();
	}

	$(window).load(function() {

		if ($(this).scrollTop() > 0) {
    		$('#main_nav').addClass('scrolled').removeClass('not_scrolled');
    	} else {
    		$('#main_nav').removeClass('scrolled');
    	}

	});

	// $(window).on('resize', function () {
	// 	if ($('#main_nav.scrolled').length > 0) {
	// 		var navResizeScrolledHeight = $('#main_nav.scrolled').outerHeight(true);
	// 		console.log(navResizeScrolledHeight);
	// 		setTimeout(function () {
	// 			$('.sub_menu').css('height','calc(100vh - ' + navResizeScrolledHeight + 'px)');
	// 		}, 100);
	// 	}
	// 	if ($('#main_nav.not_scrolled').length > 0) {
	// 		var navResizeNotScrolledHeight = $('#main_nav.not_scrolled').outerHeight(true);
	// 		console.log(navResizeNotScrolledHeight);
	// 		setTimeout(function () {
	// 			$('.sub_menu').css('height','calc(100vh - ' + navResizeNotScrolledHeight + 'px)');
	// 		}, 100);
	// 	}
	// });


	// Custom Modal overlay
	if ( $('#custom-overlay').length > 0 ) {
		if ( $.cookie('customModal') ) {
			// If cookie present, do nothing

		} else {
			// If no cookie, show modal
			$('#custom-overlay').addClass('show');
			$('body').addClass('custom-overlay-active');
		}

		// On click, hide modal and set cookie
		$('#custom-overlay a, #custom-overlay button').on('click',function(){
			// event.preventDefault();
			$('#custom-overlay').removeClass('show');
			$('body').removeClass('custom-overlay-active');
			$.cookie('customModal', 'true', { expires: 2, path: '/', secure: true });
		});
	}

	// Colour Swap
	$('.colour_swap button').click(function(event) {
		event.preventDefault();
		if($('.swappable').hasClass('invert')) {
			$.cookie('invert', 'false', { expires: 2, path: '/', secure: true });
			$('.swappable').removeClass('invert');
		} else {
			$('.swappable').addClass('invert');
			$.cookie('invert', 'true', { expires: 2, path: '/', secure: true });
		}
	});

	$('.colour_swap_mobile button').click(function(event) {
		event.preventDefault();
		if($('.swappable').hasClass('invert')) {
			$('.swappable').removeClass('invert');
			$.cookie('invert', 'false', { expires: 2, path: '/', secure: true });
		} else {
			$('.swappable').addClass('invert');
			$.cookie('invert', 'true', { expires: 2, path: '/', secure: true });
		}
	});

	$('#main_nav_menu_list .hasSub a').click(function(event) {
		event.preventDefault();
		var target = $(this).attr('href');
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(target).removeClass('show_sub');
			$('#main_nav_menu').removeClass('no_close').removeClass('menu_open');
			$('#main_nav').removeClass('menu_open');
			$('body').removeClass('modal-open');
		} else {
			$('body').addClass('modal-open');
			$('#main_nav').addClass('menu_open');
			$('#main_nav_menu').addClass('no_close').addClass('menu_open');
			var mainNavHeight = $('#main_nav').outerHeight(true);
			$('.sub_menu').css('height','calc(100vh - ' + mainNavHeight + 'px)');
			$('#main_nav_menu_list .hasSub a').not(this).removeClass('active');
			$(this).addClass('active');
			$('.sub_menu').removeClass('show_sub');
			setTimeout(function() {
    			$(target).addClass('show_sub');
    		}, 300);
			
		}
	});

	$('.cat_menu .nav-link[href^="#"]').click(function(event) {
		event.preventDefault();
		var target = $(this).attr('href');
		if($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(target).removeClass('active');
		} else {
			$('.cat_menu .nav-link').not(this).removeClass('active');
			$(this).addClass('active');
			$('.sub_menu_list').removeClass('active');
			$(target).addClass('active');
		}
	});

	$('.sub_menu_list').matchHeight({
		target: $('.sub_menu .card-img'),
	});

	var scrollPos;

	$('.hamburger').click(function() {
		$('.hamburger').toggleClass('is-active');
		$('.mobile_sub').removeClass('active');
		$('#mobile_menu').removeClass('inactive');
		if($('#page').hasClass('scale_down')) {
			console.log(scrollPos);
			$('#page').removeClass('scale_down').animate();
			$('#page').removeClass('scale_init');
			window.scrollTo(0,scrollPos);
			$('#main_nav').css('top',0).removeClass('menu_open');
		} else {
			scrollPos = window.pageYOffset;
			console.log(scrollPos);
			setTimeout(function() {
				$('#page').addClass('scale_init');
				$('#page').addClass('scale_down').animate({
					scrollTop: scrollPos,
				});
				$('#main_nav').css('top',scrollPos).addClass('menu_open');
			}, 300);
			
			
		}
	});

	$('#mobile_menu .nav-link[href^="#"]').click(function(event) {
		event.preventDefault();
		var m_target = $(this).attr('href');
		$(m_target).addClass('active');
		$('#mobile_menu').addClass('inactive');
	});

	$('.close_sub').click(function(event) {
		event.preventDefault();
		var m_target = $(this).attr('href');
		$(m_target).removeClass('active');
		$('#mobile_menu').removeClass('inactive');
	});

	$('.sub_menu .close_menu').click(function(event) {
		event.preventDefault();
		var target = $(this).data('target');
		$(target).removeClass('show_sub');
		$('#main_nav_menu_list a[href="'+target+'"]').removeClass('active');
		$('body').removeClass('modal-open');
		$('#main_nav_menu').removeClass('no_close').removeClass('menu_open');
		$('#main_nav').removeClass('menu_open');
	});

	if ($('.page-template-fees').length > 0) {
		var contentHeight = $('#content').outerHeight(true);
		$(window).scroll(function() {

			if ($(this).scrollTop() > contentHeight) {
				var mainNavScrollHeight = $('#main_nav.scrolled').outerHeight(true);
	    		$('#fees_nav_secondary').addClass('scrolled').css('top',mainNavScrollHeight);
	    	} else {
	    		$('#fees_nav_secondary').removeClass('scrolled').css('top','-100vh');
	    	}

		});
		$(window).load(function() {

			if ($(this).scrollTop() > contentHeight) {
				var mainNavScrollHeight = $('#main_nav.scrolled').outerHeight(true);
	    		$('#fees_nav_secondary').addClass('scrolled').css('top',mainNavScrollHeight);
	    	} else {
	    		$('#fees_nav_secondary').removeClass('scrolled').css('top','-100vh');
	    	}

		});


		

		$('#fees_nav_list_tab button').click(function() {
			var label = $(this).data('label');
			var target = $(this).data('bs-target');
			$('.tab-pane').not(target).removeClass('show').removeClass('active');
			$('#fees_nav_toggle span').text(label);
			$('#fees_nav_toggle').attr('aria-expanded',false);
			$('#fees_nav_list').removeClass('show');
			$('#fees_nav_secondary_toggle span').text(label);
			$('#fees_nav_secondary_toggle').attr('aria-expanded',false);
			$('#fees_nav_secondary_list').removeClass('show');
		});

		$('#fees_nav_secondary_list_tab button').click(function() {
			var label = $(this).data('label');
			var target = $(this).data('bs-target');
			$('.tab-pane').not(target).removeClass('show').removeClass('active');
			$('#fees_nav_secondary_toggle span').text(label);
			$('#fees_nav_secondary_toggle').attr('aria-expanded',false);
			$('#fees_nav_secondary_list').removeClass('show');
			$('#fees_nav_toggle span').text(label);
			$('#fees_nav_toggle').attr('aria-expanded',false);
			$('#fees_nav_list').removeClass('show');
		});
	}

	if ($('.page-template-contact').length > 0) {
		$('#field_4_5 select').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'Nearest Hospital*',
			dropdownCssClass: 'filter_dropdown',
		});
		$('#field_4_7 select').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'Treatment/Concern of interest*',
			dropdownCssClass: 'filter_dropdown',
		});
		$('#field_4_8 select').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'How did you find LaserVision?*',
			dropdownCssClass: 'filter_dropdown',
		});
		if ($('#technology').length > 0) {
			var techHeight = $('#technology .card').outerHeight(true);
			var techHeightNew = techHeight / 2;
			$('#technology_bg').css('height',techHeightNew);
		};
	};

	if ($('.page-template-landing').length > 0) {
		$('#field_4_5 select').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'Nearest Hospital*',
			dropdownCssClass: 'filter_dropdown',
		});
		$('#field_4_7 select').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'Treatment/Concern of interest*',
			dropdownCssClass: 'filter_dropdown',
		});
		$('#field_4_8 select').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'How did you find LaserVision?*',
			dropdownCssClass: 'filter_dropdown',
		});
	};

	if ($('.page-template-home').length > 0) {
		$('#header_carousel_text').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
		    var i = (currentSlide ? currentSlide : 0) + 1;
		    var slidesToShow = slick.slickGetOption('slidesToShow');
		    var curPage = parseInt((i-1)/slidesToShow) + 1;
		    var lastPage =  parseInt((slick.slideCount-1)/slidesToShow) + 1;
		    $('.slideCount').html(curPage);
		    $('.slideTotal').html(lastPage);
		});

		$('#header_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			dots: false,
			fade: true,
			speed: 750,
			cssEase: 'linear',
			prevArrow: $('.slide_prev'),
			nextArrow: $('.slide_next'),
			asNavFor: $('#header_carousel_text'),
		});
		$('#header_carousel_text').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: false,
			dots: true,
			speed: 750,
			cssEase: 'linear',
			fade: true,
			asNavFor: $('#header_carousel'),
			customPaging : function(slider, i) {
        		var slidernav = $(slider.$slides[i]).data('slidernav');
        		return '<a class="text-white text_link fs_18">'+slidernav+'</a>';
    		},
    		responsive: [
			    {
			      	breakpoint: 992,
			     	settings: {
			        	arrows: true,
			        	autoplay: false,
			        	prevArrow: $('.slide_xs_prev'),
						nextArrow: $('.slide_xs_next'),
						dots: false,
			      	}
			    },
			]

		});

		$('#header_carousel_nav a[data-slide]').click(function(e) {
	   		e.preventDefault();
		   	var slideno = $(this).data('slide');
		   	$('#header_carousel').slick('slickGoTo', slideno);
		   	$('#header_carousel_nav a').removeClass('active');
		   	$(this).addClass('active');
		});

		var $as_slider = $('#as_seen_in_carousel');
		var $as_progressBar = $('.as_seen_in_progress');
  		var $as_progressBarLabel = $( '.as_seen_in_progress .slider__label' );

		$as_slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
		    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
		    
		    $as_progressBar
		      	.css('background-size', calc + '% 100%')
		      	.attr('aria-valuenow', calc );
		    
		    $as_progressBarLabel.text( calc + '% completed' );
	  	});

		$('#as_seen_in_carousel').slick({
			autoplay: true,
			autoplaySpeed: 3000,
			slidesToShow: 4,
			slidesToScroll: 1,
			arrows: true,
			infinite: true,
			centerMode: false,
			prevArrow: $('.seen_prev'),
			nextArrow: $('.seen_next'),
			responsive: [
			    {
			      	breakpoint: 769,
			     	settings: {
			        	slidesToShow: 2,
			        	slidesToScroll: 1,
			        	arrows: false,
			      	}
			    },
			    {
			      	breakpoint: 480,
			      	settings: {
			        	slidesToShow: 1,
			        	slidesToScroll: 1,
			        	arrows: false,
			      	}
			    }
			]
		});

		
	};

	if ($('#videos_carousel').length > 0) {

		var $v_slider = $('#videos_carousel');
		var $v_progressBar = $('.videos_progress');
  		var $v_progressBarLabel = $( '.videos_progress .slider__label' );

		$v_slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
		    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
		    
		    $v_progressBar
		      	.css('background-size', calc + '% 100%')
		      	.attr('aria-valuenow', calc );
		    
		    $v_progressBarLabel.text( calc + '% completed' );
	  	});

		$('#videos_carousel').slick({
			slidesToShow: 2.667,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			infinite: true,
			centerMode: false,
			prevArrow: $('.video_prev'),
			nextArrow: $('.video_next'),
			responsive: [
			    {
			      	breakpoint: 991,
			     	settings: {
			        	slidesToShow: 2,
			        	slidesToScroll: 1,
			      	}
			    },
			    {
			      	breakpoint: 769,
			     	settings: {
			        	slidesToShow: 1,
			        	slidesToScroll: 1,
			        	fade: true,
			        	autoplay: false,
			      	}
			    },
			    {
			      	breakpoint: 480,
			      	settings: {
			      		arrows: true,
			        	slidesToShow: 1,
			        	slidesToScroll: 1,
			        	fade: true,
			        	autoplay: false,
			      	}
			    }
			]
		});

	};

	if ($('#treatment_videos').length > 0) {

		$('#treatment_videos').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
			$.fn.matchHeight._groups;
		});

		$('#treatment_videos').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			prevArrow: $('.video_prev'),
			nextArrow: $('.video_next'),
			infinite: true,
			centerMode: false,
			responsive: [
			    {
			      	breakpoint: 991,
			     	settings: {
			        	slidesToShow: 2,
			        	slidesToScroll: 1,
			      	}
			    },
			    {
			      	breakpoint: 769,
			     	settings: {
			        	slidesToShow: 1,
			        	slidesToScroll: 1,
			        	fade: true,
			        	autoplay: false,
			      	}
			    },
			    {
			      	breakpoint: 480,
			      	settings: {
			        	slidesToShow: 1,
			        	slidesToScroll: 1,
			        	fade: true,
			        	autoplay: false,
			      	}
			    }
			]
		});

	};

	if ($('#spotlight_carousel').length > 0) {

		var $slider = $('#spotlight_carousel');
		var $progressBar = $('.progress');
			var $progressBarLabel = $( '.slider__label' );

		$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
		    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
		    
		    $progressBar
		      	.css('background-size', calc + '% 100%')
		      	.attr('aria-valuenow', calc );
		    
		    $progressBarLabel.text( calc + '% completed' );
	  	});

	  	$('#spotlight_carousel .slide').on('mouseenter', function (e) {
	  		$(this).addClass('hover');
	  		$('#spotlight_carousel .slide').not(this).addClass('no_hover');
	  	}).on('mouseleave', function(e) {
	  		$(this).removeClass('hover');
	  		$('#spotlight_carousel .slide').removeClass('no_hover');
	  	});

		$('#spotlight_carousel').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			infinite: true,
			centerMode: true,
			prevArrow: $('.spot_prev'),
			nextArrow: $('.spot_next'),
			responsive: [
			    {
			      	breakpoint: 769,
			     	settings: {
			        	slidesToShow: 2,
			        	slidesToScroll: 1,
			      	}
			    },
			    {
			      	breakpoint: 480,
			      	settings: {
			        	slidesToShow: 1,
			        	slidesToScroll: 1,
			        	fade: true,
			      	}
			    }
			]
		});

	};

	if ($('#spotlight_concerns_carousel').length > 0) {

		var $concern_slider = $('#spotlight_concerns_carousel');
		var $concern_progressBar = $('.progress_concern');
		var $concern_progressBarLabel = $( '.progress_concern .slider__label' );

		$concern_slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
		    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
		    
		    $concern_progressBar
		      	.css('background-size', calc + '% 100%')
		      	.attr('aria-valuenow', calc );
		    
		    $concern_progressBarLabel.text( calc + '% completed' );
	  	});

	  	$('#spotlight_concerns_carousel .slide').on('mouseenter', function (e) {
	  		$(this).addClass('hover');
	  		$('#spotlight_concerns_carousel .slide').not(this).addClass('no_hover');
	  	}).on('mouseleave', function(e) {
	  		$(this).removeClass('hover');
	  		$('#spotlight_concerns_carousel .slide').removeClass('no_hover');
	  	});

		$('#spotlight_concerns_carousel').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			infinite: true,
			centerMode: true,
			prevArrow: $('.concern_prev'),
			nextArrow: $('.concern_next'),
			responsive: [
			    {
			      	breakpoint: 769,
			     	settings: {
			        	slidesToShow: 2,
			        	slidesToScroll: 1,
			      	}
			    },
			    {
			      	breakpoint: 480,
			      	settings: {
			        	slidesToShow: 1,
			        	slidesToScroll: 1,
			        	fade: true,
			      	}
			    }
			]
		});

	};

	if ($('#before_afters_carousel').length > 0) {

		$('#before_afters_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			arrows: true,
			prevArrow: $('.gallery_prev'),
			nextArrow: $('.gallery_next'),
			infinite: true,
			centerMode: false,
			fade: true,
		});

	};

	$('.launch_video').click(function() {
		var src = $(this).data('src');
		var type = $(this).data('type');
		$('#video_modal iframe').attr('src',src);
		$('#video_modal iframe').addClass(type);
	});

	$('#video_modal').on('hidden.bs.modal', function (e) {
		$('#video_modal .ratio iframe').attr('src','');
		$('#video_modal .ratio iframe').removeClass('.vimeo').removeClass('youtube');
	});

	if ($('.page-template-careers').length > 0) {
		var headerHeight = $('#main_nav').outerHeight(true);
		$('#content').css('padding-top',headerHeight);
	};

	if ($('.single-treatment').length > 0) {
		var headerHeight = $('#main_nav').outerHeight(true);
		$('#content').css('padding-top',headerHeight);
		$('#glance_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			prevArrow: $('.glance_prev'),
			nextArrow: $('.glance_next'),
			infinite: true,
			draggable: false,
			swipe: false,
		});
		if ($('#further_content').length > 0) {
			var $further_count = $('#further_content').find('p').length;
			console.log($further_count);
			if ($further_count <= 3) {
				$('#further_content_toggle').hide();
				$('#further_content p:nth-child(3)').toggleClass('remove_fade');
			}

			$('#further_content_toggle').click(function(event) {
				$('#further_content p:nth-child(3)').toggleClass('remove_fade');
				$(this).text($(this).text() == 'Read more' ? 'Read less' : 'Read more');
			});
		};
		if ($('#technology').length > 0) {
			var techHeight = $('#technology .card').outerHeight(true);
			var techHeightNew = techHeight / 2;
			$('#technology_bg').css('height',techHeightNew);
		};
		if ($(window).width() < 992) {
			$('#benefits .benefits_mobile').matchHeight({
				target: $('#benefits_content'),
			});
		};
		if ($(window).width() > 992) {
			$('#benefits .benefits_desktop').matchHeight({
				target: $('#benefits_content'),
			});
			$('#faq #faq_image img').matchHeight({
				target: $('#faq_container'),
			});
		}
	};

	if ($('.page-template-events').length > 0) {
		$('.accordion-button').click(function() {
			var icon = $(this).data('icon');
			if($(icon).hasClass('active')) {
				$(icon).removeClass('active');
			} else {
				$('.accordion-header i').removeClass('active');
				$(icon).addClass('active');
			}
		});
		$('.accordion-header i').click(function() {
			if($(this).hasClass('active')) {
				$(this).removeClass('active');
			} else {
				$('.accordion-header i').removeClass('active');
				$(this).addClass('active');
			}
		});
	};

	if ($('.single-condition').length > 0) {
		if ($('#technology').length > 0) {
			var techHeight = $('#technology .card').outerHeight(true);
			var techHeightNew = techHeight / 2;
			$('#technology_bg').css('height',techHeightNew);
		};
		if ($(window).width() < 992) {
			$('#causes .causes_mobile').matchHeight({
				target: $('#causes_content_mobile'),
			});
		};
		if ($(window).width() > 992) {
			$('#causes .causes_desktop').matchHeight({
				target: $('#causes_content'),
			});
		};
		if ($(window).width() > 992) {
			if ($('#need_to_know_container').length > 0) {
				var ntkHeight = $('#need_to_know_container .card').outerHeight(true);
				var ntkHeightNews = ntkHeight / 2;
				$('#need_to_know_bg').css('height',ntkHeightNews);
			};
		};

	};

	if ($('.page-template-clinics').length > 0) {
		if ($(window).width() < 992) {
			
			var block_2_height = $('#block_2_container').outerHeight(true);
			$('#block_2 .card-img').height(block_2_height);
		}
	};

	if ($('.single-location').length > 0) {
		if ($(window).width() < 992) {
			
			var block_2_height = $('#location_treatments_container').outerHeight(true);
			$('#location_treatments .card-img').height(block_2_height);
		}
	};

	if ($('#blog_filter').length > 0) {
		$('#cat').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'Category',
			dropdownCssClass: 'filter_dropdown',
		});
	};

	if ($('.page-template-team').length > 0) {
		var $grid = $('#members').imagesLoaded(function() {
			$grid.isotope({
				itemSelector: '.member',
			});
		});

		// $('#team_filter_specialism').on( 'change', function() {
		//   	// get filter value from option value
		//   	var filterValue = this.value;
		//   	$grid.isotope({ filter: filterValue });
		// });

		// $('#team_filter_location').on( 'change', function() {
		//   	// get filter value from option value
		//   	var filterValue = this.value;
		//   	$grid.isotope({ filter: filterValue });
		// });

		$('#team_filter_specialism').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'By Specialism',
			dropdownCssClass: 'filter_dropdown',
			templateSelection: function (data, container) {
			    // Add custom attributes to the <option> tag for the selected option
			    $(data.element).attr('data-value', data.customValue);
			    return data.text;
		  	}
		});

		$('#team_filter_location').select2({
			minimumResultsForSearch: Infinity,
			allowClear: false,
			width: '100%',
			placeholder: 'By Location',
			dropdownCssClass: 'filter_dropdown',
			templateSelection: function (data, container) {
			    // Add custom attributes to the <option> tag for the selected option
			    $(data.element).attr('data-value', data.customValue);
			    return data.text;
		  	}
		});

		$('#team_filter_specialism').on('select2:select', function (e) {
			var target = $('#team_filter_specialism').find(':selected').data('value');
			$grid.isotope({ filter: target });
		});

		$('#team_filter_location').on('select2:select', function (e) {
			var target = $('#team_filter_location').find(':selected').data('value');
			$grid.isotope({ filter: target });
		});

	};

	if ($('.page-template-technology').length > 0) {
		if ($(window).width() < 992) {
			$('#technology_nav_mobile').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				width: '100%',
				dropdownCssClass: 'technology_dropdown',
				templateSelection: function (data, container) {
				    // Add custom attributes to the <option> tag for the selected option
				    $(data.element).attr('data-bs-target', data.customValue);
				    return data.text;
			  	}
			});
			$('#technology_nav_mobile').on('select2:select', function (e) {
				var target = $('#technology_nav_mobile').find(':selected').data('bs-target');
				$('#technology_panes .tab-pane').removeClass('show active');
				$(target).addClass('show active');
			});
		};
		
	};

	if ($('.single-team_member').length > 0) {

		if ($('#technology').length > 0) {
			var techHeight = $('#technology .card').outerHeight(true);
			var techHeightNew = techHeight / 2;
			$('#technology_bg').css('height',techHeightNew);
		};
	};
	
	if ($('.page-template-about').length > 0) {
		if ($(window).width() < 992) {
			$('#header .mobile_header').matchHeight({
				target: $('#header_container'),
			});
		}

		$('.header_trigger').click(function(event) {
			event.preventDefault();
			if ($(window).width() > 992) {
				var target = $(this).attr('href');
				$('body').addClass('modal-open');
				$('#main_nav').addClass('menu_open').addClass('scrolled');
				setTimeout(function() {
					var navScrolledHeight = $('#main_nav.scrolled').outerHeight(true);
	    			$('.sub_menu').css('height','calc(100vh - ' + navScrolledHeight + 'px)');
				}, 300);
				$('#main_nav_menu_list .menu-item-298 .nav-link').addClass('active');
				$('.sub_menu').removeClass('show_sub');
				setTimeout(function() {
		    		$(target).addClass('show_sub');
		    	}, 300);
			} else {
				$('.hamburger').toggleClass('is-active');
				$('#treatments_mobile').addClass('active');
				scrollPos = window.pageYOffset;
				console.log(scrollPos);
				setTimeout(function() {
					$('#page').addClass('scale_init');
					$('#page').addClass('scale_down').animate({
						scrollTop: scrollPos,
					});
					$('#main_nav').css('top',scrollPos).addClass('menu_open');
				}, 300);
			}
		});

		$('#awards_carousel').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			arrows: true,
			prevArrow: $('.award_prev'),
			nextArrow: $('.award_next'),
			infinite: true,
		});

		if ($('#technology').length > 0) {
			var techHeight = $('#technology .card').outerHeight(true);
			var techHeightNew = techHeight / 2;
			$('#technology_bg').css('height',techHeightNew);
		};
	};

	$('#field_2_5 .gfield_select').select2({
		minimumResultsForSearch: Infinity,
		allowClear: false,
		width: '100%',
		placeholder: 'Brochure Type',
		dropdownCssClass: 'filter_dropdown',
	});

	if ($('#clinics_carousel').length > 0) {

		
		var $clinics_slider = $('#clinics_carousel');
		var $clinics_progressBar = $('.clinics_progress');
		var $clinics_progressBarLabel = $( '.clinics_progress .slider__label' );

		$clinics_slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {  
			
		    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
		    
		    $clinics_progressBar
		      	.css('background-size', calc + '% 100%')
		      	.attr('aria-valuenow', calc );
		    
		    $clinics_progressBarLabel.text( calc + '% completed' );
	  	});

	  	
		$('#clinics_carousel').on('init', function(event, slick, direction){
			var clinic_image_height = $('#clinics_carousel .card-img-top').height();
			if ($(window).width() > 992) {
				var clinic_image_height_new = clinic_image_height / 2;
			} else {
				var clinic_image_height_new = clinic_image_height - 20;
			}
			$('#clinics_bg').css('height',clinic_image_height_new);
		  	
		});

		$('#clinics_carousel').slick({

			slidesToShow: 4,
			slidesToScroll: 1,
			cssEase: 'linear',
			autoplay: true,
			speed: 10000,
			autoplaySpeed: 0,
			arrows: false,
			pauseOnHover: false,
			infinite: true,
			responsive: [
			    {
			      	breakpoint: 769,
			     	settings: {
			        	slidesToShow: 2,
			        	slidesToScroll: 1,
			        	arrows: false,
			      	}
			    },
			    {
			      	breakpoint: 480,
			      	settings: {
			      		speed: 500,
			      		autoplay: false,
			        	slidesToShow: 1,
			        	slidesToScroll: 1,
			      	}
			    }
			]
		});

	};

	$('.infographic_launch').click(function(event) {
		var src = $(this).data('src');
		var alt = $(this).data('alt');
		$('#infographic_modal img').attr('src',src).attr('alt',alt);
	});

	$('#infographic_modal').on('hidden.bs.modal', function() {
		$('#infographic_modal img').attr('src','').attr('alt','');
	});
});
